<div class=" col-md-10 mb-2 mt-2 row d-flex align-items-center" style="min-height: 3em;">
    <p-dropdown placeholder="-" [disabled]="disabled" class="mr-0 pr-0" [style]="{width: '100%'}" autoWidth="false" [(ngModel)]="baseCampaign.adUnitTypeSelected" [options]="adUnitSelectOptions" (onChange)="onAdUnitChange($event)" ></p-dropdown>
</div>
<div *ngIf="messageVisible" class=" col-md-10 mb-2 mt-2 row ml-0 invalid-message-box d-flex align-items-center" style="min-height: 3em;">
    <span class="pl-3">{{validationMessage}}</span>
</div>